var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useSyncExternalStore } from "react";
var authStore = {
    value: null,
    listeners: [],
    subscribe: function (listener) {
        authStore.listeners = __spreadArray(__spreadArray([], authStore.listeners, true), [listener], false);
        return function () {
            authStore.listeners = authStore.listeners.filter(function (l) { return l !== listener; });
        };
    },
    snapshot: function () { return authStore.value; },
    update: function (newAuth) {
        authStore.value = newAuth;
        authStore.listeners.forEach(function (l) { return l(); });
    },
};
export var bindTwitchAuth = function () {
    // If Twitch isn't available, do nothing
    if (!("Twitch" in window) || !window.Twitch.ext)
        return;
    // Otherwise, listen for the auth callback
    window.Twitch.ext.onAuthorized(function (auth) {
        authStore.update(auth);
    });
};
// Twitch auth callback may be called before React is ready, so we use an external store
export default (function () {
    return useSyncExternalStore(authStore.subscribe, authStore.snapshot);
});
